import axios from 'axios';

export default {

  getElements (projectId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/elements`);
  },

  getElement (projectId, elementId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/elements/${elementId}`);
  },

  createElement (projectId, element) {
    return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/elements`, element);
  },

  updateElement (projectId, element) {
    return axios.put(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/elements/${element.id}`, element);
  },

  deleteElement (projectId, elementId) {
    return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/elements/${elementId}`);
  },
};